import React from "react";
import { useEffect, useState, useRef } from "react";
import NavButton from "../../homepage/header-banner/TopNavButton";
import Vitess from "../../homepage/header-banner/Vitess";
import Footer from "../../homepage/footer/Footer";
import Cloudconsult from "../../homepage/consult/cloudconsult";
import Banner from "../../container/Banner/Banner";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../container/Sidebar/Sidebar";
import "../../container/Sidebar/sidebar.css";
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard";
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute";
import CardBox from "../../container/Box/Components/CardBox";
// import { MuiGrid } from '@mui/material';
import CloudConsultCp from "../../homepage/consult/cloudconsult-cp";
import "../../Style/typo.css";
import Cloudconsult2 from "../../homepage/consult/cloudconsult-2";
import BannerPrivateCloud from "../../container/Banner/banner-privateCloud";
import DividerComponent from "../../container/Divider/divider";
import styled from "styled-components";
import useIsMobile from "../../container/Sidebar/useIsMobile";
import BannerPrivateCloudVN from "../../container/Banner/banner-privateCloud-vn";
import Cloudconsult2VN from "../../homepage/consult/cloudconsult-2-vn";
import SidebarVN from "../../container/Sidebar/Sidebar-vn";
import HeaderVn from "../../detailpageVN/Page/component/headervn";
import FooterVn from "../../detailpageVN/Page/component/footervn";

const Sysfont = styled.div`
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
`;

function ClustercloudvitessVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = "Private Vitess Cluster - Private Kubernetes - Private Cloud";
    }, []);
    return (
        <Sysfont className="App">
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for Vitess")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Nền tảng cloud phân phối, sao chép và quản lý container MySQL (POD)</p>",
                                    `<p class='typo-14'>Vitess là giải pháp tối ưu cho việc mở rộng quy mô và quản lý hiệu quả các cluster lớn sử dụng container MySQL (POD). </p>
                                <p class='typo-14'>Hệ thống hỗ trợ nhiều tính năng như phân mảnh đọc, phân mảnh ngang và mở rộng linh hoạt.    </p>
                                <p class='typo-14'>Vitess cho phép kết hợp giữa MySQL chính với NoSQL DB, mang lại khả năng mở rộng linh hoạt mà không cần thay đổi nhiều về hạ tầng nội bộ.</p>
                                <p class='typo-14'>Là giải pháp được YouTube lựa chọn để quản lý dữ liệu quy mô lớn, đảm bảo hiệu năng và độ tin cậy cao.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Vận hành Persistent Volume với hiệu suất cao, tối ưu hóa hiệu suất I/O, sử dụng SSD làm nền tảng lưu trữ.</p>",
                                    `<p class='typo-14'>Dịch vụ bao gồm 3 container replica (POD), mỗi container hoạt động như một đơn vị dịch vụ độc lập.</p>
                                <p class='typo-14'>Ngay cả khi phần cứng của một worker node trong Kubernetes gặp sự cố, dịch vụ vẫn tiếp tục hoạt động trên các container (POD) của những worker node khác mà không bị gián đoạn.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Hệ thống tự động di chuyển container (POD) khi có sự cố phần cứng, đảm bảo hoạt động liên tục và không gián đoạn.</p>",
                                    `<p class='typo-14'>Các container (POD) của Kubernetes Vitess bao gồm 3 node replica cho mỗi dịch vụ đơn vị.</p>
                                <p class='typo-14'>Các replica container (POD) được phân bổ phân tán trên nhiều worker node trong Kubernetes, giúp tối ưu khả năng chịu lỗi và tính sẵn sàng của hệ thống.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>
                                {CardBox(
                                    "<p class='typo-21-sm typo-medium typo-black'>Hệ thống tự động mở rộng quy mô (Autoscaling), tự động điều chỉnh số lượng container và phân phối tải dịch vụ.</p>",
                                    `<p class='typo-14'>Số lượng container (POD) được điều chỉnh dựa trên các chỉ số như CPU, bộ nhớ hoặc các metric tùy chỉnh theo định kỳ.</p>
                                <p class='typo-14'>Hệ thống có thể vận hành mà không cần bổ sung tài nguyên phần cứng cho việc mở rộng dịch vụ.</p>
                                <p class='typo-14'>Đây là giải pháp cluster hiệu quả trong việc phân phối tải dịch vụ và tối ưu chi phí.</p>`,
                                )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>
                                {Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-cloud-vitess/vitess_cluster.svg")}
                            </MuiGrid>
                            <DividerComponent />
                        </MuiGrid>

                        {/* <Vitess /> */}
                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>

            <FooterVn />
        </Sysfont>
    );
}

const MuiGrid = styled.div`
    padding: 0px;
`;

export default ClustercloudvitessVN;
